// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.absence-form-page {
    max-width: 916px;
    width: 100%;
    margin: 150px auto 0;
    padding: 0 16px 32px;
    box-sizing: border-box;
}

.absence-form-page .padding-body-2 {
    padding: 0;
}

.absence-form-page .MuiPaper-root {
    background: #ffffff !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.absence-form-page form {
    padding: 12px 0 24px;
    background: transparent;
}

.absence-form-page form h5 {
    color: #1f84b9;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 10px;
}

.absence-form-page .validation-message {
    color: #ef6a55;
    margin-bottom: 12px;
}

.absence-form-page .MuiInputBase-root {
    border-radius: 8px !important;
    background: #d7e3ec !important;
}

.absence-form-page .MuiSelect-select {
    border-radius: 8px !important;
    background: #d7e3ec !important;
}

.absence-form-page .MuiOutlinedInput-notchedOutline {
    border-color: #1f84b9 !important;
}

.absence-form-page .MuiInputBase-input,
.absence-form-page .MuiSelect-select {
    color: #0d4d8d !important;
    font-size: 18px;
}

.absence-form-page .MuiFormLabel-root {
    color: #0d4d8d !important;
    font-size: 16px;
}

.absence-form-page .buttonFilled {
    margin-top: 8px !important;
    border-radius: 10px !important;
    background-color: #1ea8eb !important;
    min-height: 44px;
    box-shadow: none !important;
    text-transform: uppercase;
}

.absence-form-page .buttonFilled:hover {
    background-color: #1799d8 !important;
}

.absence-form-page .cancelButton {
    margin-top: 6px;
    color: #0d4d8d;
}

.absence-form-page input[type='date']::-webkit-calendar-picker-indicator {
    opacity: 1 !important;
    filter: none !important;
    cursor: pointer;
}

.absence-form-page .MuiSvgIcon-root {
    color: #0d4d8d !important;
}

@media only screen and (max-width: 1024px) {
    body.absence-form-route .home-header .logo {
        background: none !important;
        width: auto;
        height: auto;
        margin-top: 0 !important;
        display: inline-flex;
        align-items: baseline;
        gap: 0;
        text-transform: none;
        line-height: 1;
    }

    body.absence-form-route .home-header .logo::before {
        content: 'Agema';
        color: #1f1f1f;
        font-size: clamp(30px, 6.8vw, 46px);
        font-weight: 500;
        letter-spacing: -0.02em;
    }

    body.absence-form-route .home-header .logo::after {
        content: 'HOME';
        color: #2280b3;
        font-size: clamp(30px, 6.8vw, 46px);
        font-weight: 700;
        letter-spacing: -0.02em;
    }

    .absence-form-page {
        max-width: none;
        width: 100%;
        margin: 0 auto;
        padding: 0 16px 24px;
        box-sizing: border-box;
    }

    .absence-form-page .padding-body-2 {
        padding: 12px 0 20px;
    }

    .absence-form-page .MuiPaper-root {
        background: #ffffff !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
    }

    .absence-form-page form {
        padding: 12px 12px 22px;
    }

    .absence-form-page form h5 {
        color: #1f84b9;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 10px;
    }

    .absence-form-page .validation-message {
        color: #ef6a55;
        margin-bottom: 12px;
    }

    .absence-form-page .MuiInputBase-root,
    .absence-form-page .MuiSelect-select {
        border-radius: 8px !important;
        background: #d7e3ec !important;
    }

    .absence-form-page .MuiOutlinedInput-notchedOutline {
        border-color: #1f84b9 !important;
    }

    .absence-form-page .MuiInputBase-input,
    .absence-form-page .MuiSelect-select {
        color: #0d4d8d !important;
        font-size: 18px;
    }

    .absence-form-page .MuiFormLabel-root {
        color: #0d4d8d !important;
        font-size: 16px;
    }

    .absence-form-page .buttonFilled {
        margin-top: 8px !important;
        border-radius: 10px !important;
        background-color: #1ea8eb !important;
        min-height: 44px;
        box-shadow: none !important;
        text-transform: uppercase;
    }

    .absence-form-page .cancelButton {
        margin-top: 6px;
        color: #0d4d8d;
    }

    .absence-form-page input[type='date']::-webkit-calendar-picker-indicator {
        opacity: 1 !important;
        filter: none !important;
        cursor: pointer;
    }

    .absence-form-page .MuiSvgIcon-root {
        color: #0d4d8d !important;
    }
}

@media only screen and (max-width: 820px) {
    .absence-form-page {
        max-width: none;
        padding: 0 16px 20px;
    }

    .absence-form-page .padding-body-2 {
        padding: 10px 0 14px;
    }

    .absence-form-page form {
        padding: 10px 10px 18px;
    }

    .absence-form-page form h5 {
        font-size: 20px;
    }

    .absence-form-page .MuiInputBase-input,
    .absence-form-page .MuiSelect-select {
        font-size: 14px;
    }

    .absence-form-page .MuiFormLabel-root {
        font-size: 13px;
    }
}

@media (prefers-color-scheme: dark) and (max-width: 1024px) {
    body.absence-form-route .home-header .navbarContainer {
        background: #11161d !important;
        border-bottom: 1px solid #26313b;
    }

    body.absence-form-route .home-header .logo::before {
        color: #f1f5f9;
    }

    .absence-form-page,
    .absence-form-page .padding-body-2 {
        background: #0b1016;
    }

    .absence-form-page .MuiPaper-root {
        background: #101922 !important;
    }

    .absence-form-page form {
        background: transparent !important;
        color: #e5eef7 !important;
    }

    .absence-form-page form h5 {
        color: #59b4e6;
    }

    .absence-form-page .MuiInputBase-root,
    .absence-form-page .MuiSelect-select {
        background: #1a2733 !important;
    }

    .absence-form-page .MuiOutlinedInput-notchedOutline {
        border-color: #2a9cda !important;
    }

    .absence-form-page .MuiInputBase-input,
    .absence-form-page .MuiSelect-select,
    .absence-form-page .MuiFormLabel-root,
    .absence-form-page .cancelButton {
        color: #ffffff !important;
        -webkit-text-fill-color: #ffffff !important;
    }
}

@media (prefers-color-scheme: dark) {
    .absence-form-page .MuiInputBase-root,
    .absence-form-page .MuiSelect-select {
        background: #1a2733 !important;
    }

    .absence-form-page .MuiOutlinedInput-notchedOutline {
        border-color: #2a9cda !important;
    }

    .absence-form-page .MuiInputBase-input,
    .absence-form-page .MuiSelect-select,
    .absence-form-page .MuiFormLabel-root {
        color: #ffffff !important;
        -webkit-text-fill-color: #ffffff !important;
    }

    .absence-form-page .MuiSvgIcon-root {
        color: #ffffff !important;
    }

    .absence-form-page input[type='date']::-webkit-calendar-picker-indicator {
        filter: invert(1) !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/absence/absenceComponent.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,oCAAoC;IACpC,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,2BAA2B;QAC3B,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;QACrB,MAAM;QACN,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,mCAAmC;QACnC,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,cAAc;QACd,mCAAmC;QACnC,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,cAAc;QACd,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,8BAA8B;QAC9B,oBAAoB;QACpB,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;;QAEI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;QAC9B,oCAAoC;QACpC,gBAAgB;QAChB,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;QAClC,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;;;QAII,yBAAyB;QACzB,2CAA2C;IAC/C;AACJ;;AAEA;IACI;;QAEI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;;QAGI,yBAAyB;QACzB,2CAA2C;IAC/C;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".absence-form-page {\r\n    max-width: 916px;\r\n    width: 100%;\r\n    margin: 150px auto 0;\r\n    padding: 0 16px 32px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.absence-form-page .padding-body-2 {\r\n    padding: 0;\r\n}\r\n\r\n.absence-form-page .MuiPaper-root {\r\n    background: #ffffff !important;\r\n    border: 0 !important;\r\n    border-radius: 0 !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.absence-form-page form {\r\n    padding: 12px 0 24px;\r\n    background: transparent;\r\n}\r\n\r\n.absence-form-page form h5 {\r\n    color: #1f84b9;\r\n    font-size: 24px;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.absence-form-page .validation-message {\r\n    color: #ef6a55;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.absence-form-page .MuiInputBase-root {\r\n    border-radius: 8px !important;\r\n    background: #d7e3ec !important;\r\n}\r\n\r\n.absence-form-page .MuiSelect-select {\r\n    border-radius: 8px !important;\r\n    background: #d7e3ec !important;\r\n}\r\n\r\n.absence-form-page .MuiOutlinedInput-notchedOutline {\r\n    border-color: #1f84b9 !important;\r\n}\r\n\r\n.absence-form-page .MuiInputBase-input,\r\n.absence-form-page .MuiSelect-select {\r\n    color: #0d4d8d !important;\r\n    font-size: 18px;\r\n}\r\n\r\n.absence-form-page .MuiFormLabel-root {\r\n    color: #0d4d8d !important;\r\n    font-size: 16px;\r\n}\r\n\r\n.absence-form-page .buttonFilled {\r\n    margin-top: 8px !important;\r\n    border-radius: 10px !important;\r\n    background-color: #1ea8eb !important;\r\n    min-height: 44px;\r\n    box-shadow: none !important;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.absence-form-page .buttonFilled:hover {\r\n    background-color: #1799d8 !important;\r\n}\r\n\r\n.absence-form-page .cancelButton {\r\n    margin-top: 6px;\r\n    color: #0d4d8d;\r\n}\r\n\r\n.absence-form-page input[type='date']::-webkit-calendar-picker-indicator {\r\n    opacity: 1 !important;\r\n    filter: none !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.absence-form-page .MuiSvgIcon-root {\r\n    color: #0d4d8d !important;\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    body.absence-form-route .home-header .logo {\r\n        background: none !important;\r\n        width: auto;\r\n        height: auto;\r\n        margin-top: 0 !important;\r\n        display: inline-flex;\r\n        align-items: baseline;\r\n        gap: 0;\r\n        text-transform: none;\r\n        line-height: 1;\r\n    }\r\n\r\n    body.absence-form-route .home-header .logo::before {\r\n        content: 'Agema';\r\n        color: #1f1f1f;\r\n        font-size: clamp(30px, 6.8vw, 46px);\r\n        font-weight: 500;\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    body.absence-form-route .home-header .logo::after {\r\n        content: 'HOME';\r\n        color: #2280b3;\r\n        font-size: clamp(30px, 6.8vw, 46px);\r\n        font-weight: 700;\r\n        letter-spacing: -0.02em;\r\n    }\r\n\r\n    .absence-form-page {\r\n        max-width: none;\r\n        width: 100%;\r\n        margin: 0 auto;\r\n        padding: 0 16px 24px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .absence-form-page .padding-body-2 {\r\n        padding: 12px 0 20px;\r\n    }\r\n\r\n    .absence-form-page .MuiPaper-root {\r\n        background: #ffffff !important;\r\n        border: 0 !important;\r\n        border-radius: 0 !important;\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    .absence-form-page form {\r\n        padding: 12px 12px 22px;\r\n    }\r\n\r\n    .absence-form-page form h5 {\r\n        color: #1f84b9;\r\n        font-size: 24px;\r\n        font-weight: 500;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .absence-form-page .validation-message {\r\n        color: #ef6a55;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    .absence-form-page .MuiInputBase-root,\r\n    .absence-form-page .MuiSelect-select {\r\n        border-radius: 8px !important;\r\n        background: #d7e3ec !important;\r\n    }\r\n\r\n    .absence-form-page .MuiOutlinedInput-notchedOutline {\r\n        border-color: #1f84b9 !important;\r\n    }\r\n\r\n    .absence-form-page .MuiInputBase-input,\r\n    .absence-form-page .MuiSelect-select {\r\n        color: #0d4d8d !important;\r\n        font-size: 18px;\r\n    }\r\n\r\n    .absence-form-page .MuiFormLabel-root {\r\n        color: #0d4d8d !important;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .absence-form-page .buttonFilled {\r\n        margin-top: 8px !important;\r\n        border-radius: 10px !important;\r\n        background-color: #1ea8eb !important;\r\n        min-height: 44px;\r\n        box-shadow: none !important;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .absence-form-page .cancelButton {\r\n        margin-top: 6px;\r\n        color: #0d4d8d;\r\n    }\r\n\r\n    .absence-form-page input[type='date']::-webkit-calendar-picker-indicator {\r\n        opacity: 1 !important;\r\n        filter: none !important;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .absence-form-page .MuiSvgIcon-root {\r\n        color: #0d4d8d !important;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 820px) {\r\n    .absence-form-page {\r\n        max-width: none;\r\n        padding: 0 16px 20px;\r\n    }\r\n\r\n    .absence-form-page .padding-body-2 {\r\n        padding: 10px 0 14px;\r\n    }\r\n\r\n    .absence-form-page form {\r\n        padding: 10px 10px 18px;\r\n    }\r\n\r\n    .absence-form-page form h5 {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .absence-form-page .MuiInputBase-input,\r\n    .absence-form-page .MuiSelect-select {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .absence-form-page .MuiFormLabel-root {\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) and (max-width: 1024px) {\r\n    body.absence-form-route .home-header .navbarContainer {\r\n        background: #11161d !important;\r\n        border-bottom: 1px solid #26313b;\r\n    }\r\n\r\n    body.absence-form-route .home-header .logo::before {\r\n        color: #f1f5f9;\r\n    }\r\n\r\n    .absence-form-page,\r\n    .absence-form-page .padding-body-2 {\r\n        background: #0b1016;\r\n    }\r\n\r\n    .absence-form-page .MuiPaper-root {\r\n        background: #101922 !important;\r\n    }\r\n\r\n    .absence-form-page form {\r\n        background: transparent !important;\r\n        color: #e5eef7 !important;\r\n    }\r\n\r\n    .absence-form-page form h5 {\r\n        color: #59b4e6;\r\n    }\r\n\r\n    .absence-form-page .MuiInputBase-root,\r\n    .absence-form-page .MuiSelect-select {\r\n        background: #1a2733 !important;\r\n    }\r\n\r\n    .absence-form-page .MuiOutlinedInput-notchedOutline {\r\n        border-color: #2a9cda !important;\r\n    }\r\n\r\n    .absence-form-page .MuiInputBase-input,\r\n    .absence-form-page .MuiSelect-select,\r\n    .absence-form-page .MuiFormLabel-root,\r\n    .absence-form-page .cancelButton {\r\n        color: #ffffff !important;\r\n        -webkit-text-fill-color: #ffffff !important;\r\n    }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\n    .absence-form-page .MuiInputBase-root,\n    .absence-form-page .MuiSelect-select {\n        background: #1a2733 !important;\n    }\n\n    .absence-form-page .MuiOutlinedInput-notchedOutline {\n        border-color: #2a9cda !important;\n    }\n\n    .absence-form-page .MuiInputBase-input,\n    .absence-form-page .MuiSelect-select,\n    .absence-form-page .MuiFormLabel-root {\n        color: #ffffff !important;\n        -webkit-text-fill-color: #ffffff !important;\n    }\n\n    .absence-form-page .MuiSvgIcon-root {\n        color: #ffffff !important;\n    }\n\n    .absence-form-page input[type='date']::-webkit-calendar-picker-indicator {\n        filter: invert(1) !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
